/*
 Copy-paste of HttpService from angular-utils
 Delete this when upgrading to angular-utils > 1.4.0
 */

export class HttpService {
    /* @ngInject */
    constructor($http, egUrlService) {
        this.$http = $http;
        this.egUrlService = egUrlService;
    }

    get(url, config) {
        url = this._url(url);
        let request = this.$http.get(url, config);
        return request.then(response => response.data);
    }

    post(url, data, config) {
        url = this._url(url);
        let request = this.$http.post(url, data, config);
        return request.then(response => response.data);
    }

    put(url, data, config) {
        url = this._url(url);
        let request = this.$http.put(url, data, config);
        return request.then(response => response.data);
    }

    delete(url, config) {
        url = this._url(url);
        let request = this.$http.delete(url, config);
        return request.then(response => response.data);
    }

    _url(url) {
        return this.egUrlService.url(url);
    }
}